import React from 'react';
import * as ds from './dataService';
import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';

export type RemoveOnSiteWorkEventModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveOnSiteWorkEventModalProps) => {
  const [
    fnRemoveOnSiteWorkEventForm,
    { loading }
  ] = ds.useRemoveOnSiteWorkEvent();

  return (
    <InformationModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      loading={loading}
      handleClose={() => props.handleClose()}
      title='Remove Event'
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELETE'
        />
      )}
      subTitle='Are you sure to remove this event? This action cannot be undone.'
      successButton={{
        text: 'Confirm',
        handleClick: async () => {
          await fnRemoveOnSiteWorkEventForm(props.id);
          props.handleClose();

        }
      }}
      cancelButton={{
        text: 'Cancel',
        handleClick: () => props.handleClose()
      }}
    />
  );

};
